'use client';

import axios from 'axios';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Button, Col, Container, Form, FormControl, InputGroup, Row, Spinner } from 'react-bootstrap';
import { CountryDropdown } from 'react-country-region-selector';
import DatePicker from 'react-datepicker';
import Recaptcha from 'react-google-invisible-recaptcha';
import PhoneInput from 'react-phone-input-2';
import counties from './assets//country_tel_code.json';
import 'react-datepicker/dist/react-datepicker.css';
import { useParams, useRouter } from 'next/navigation';
import { Locale } from '../../../../i18n-config';
import { useHistoryState, useMediaQuery } from '@uidotdev/usehooks';
import { useTranslation } from '@/i18n/client';

const styles = {
  font_weight_bold: { fontWeight: 'bold' },
};

const Client = () => {
  const { lang } = useParams();
  const { t } = useTranslation(lang as Locale);
  const router = useRouter();

  const isMobile = useMediaQuery('only screen and (max-width : 768px)');

  const recaptchaRef = React.createRef();

  const [counter2, setCounter2] = useState(1);
  const [firstname, setFirstnamee] = useState('');
  const [lastname, setLastname] = useState('');
  const [nationality, setNationality] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [apiErrors, setApiErrors] = useState();
  const [publicphonenumber, setPublicphonenumber] = useState('');
  const [email, setEmail] = useState('');
  const [homeaddress, setHomeAddress] = useState('');
  const [fathername, setFathername] = useState('');
  const [passportimage, setPassportImage] = useState<any>('');
  const [photograph, setPhotograph] = useState<any>('');
  const [countrynumber, setCountrynymber] = useState('gb');
  const [startDate, setStartDate] = useState(new Date());
  const [validnationality, setValidNationality] = useState(false);
  const [validfirstname, setvalidFirstnamee] = useState(false);
  const [validlastname, setvalidLastname] = useState(false);
  const [validpublicphonenumber, setvalidPublicphonenumber] = useState(false);
  const [validemail, setvalidEmail] = useState(false);
  const [validhomeaddress, setvalidHomeAddress] = useState(false);
  const [validfathername, setvalidFathername] = useState(false);

  const { getCode } = require('country-list');

  const handlePassport = (e) => {
    e.preventDefault();
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setPassportImage(reader.result);
    };
  };

  const handlePhotograph = (e) => {
    e.preventDefault();
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      setPhotograph(reader.result);
    };
  };

  const RestoreVisa = () => {
    setFirstnamee('');
    setLastname('');
    setNationality('');
    setFathername('');
    setPublicphonenumber('');
    setEmail('');
    setHomeAddress('');
  };

  const submitVisa = (e) => {
    e.preventDefault();

    const visa = {
      first_name: firstname,
      last_name: lastname,
      email: email,
      country: countrynumber.toUpperCase(),
      phone_number: publicphonenumber,
      address: homeaddress,
      father_name: fathername,
      duration: counter2,
      start_date: moment(startDate).format('YYYY-MM-DD'),
      passport_photo: passportimage || undefined,
      photograph: photograph || undefined,
    };

    setIsSubmitting(true);

    axios
      .post(`https://api.iranjourney.com/api/inbox/iran_visa_request`, visa)
      .then((res) => {
        alert('submitted succssfully!');
        RestoreVisa();

        router.push(`/${lang}/successful-submit`);
      })
      .catch((err) => {
        setApiErrors(err.response.data);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const selectCountry = (val) => {
    // alert(getCode(val));
    if (val === 'United States') {
      setCountrynymber('us');
    } else if (val === 'United Kingdom') {
      setCountrynymber('gb');
    } else if (val === 'Vietnam') {
      setCountrynymber('vn');
    } else if (val === 'Cape Verde') {
      setCountrynymber('cv');
    } else if (val === 'Czech Republic') {
      setCountrynymber('cz');
    } else if (val === 'Greenland') {
      setCountrynymber('gl');
    } else if (val === 'Macedonia, Republic of') {
      setCountrynymber('mk');
    } else if (val === 'Swaziland') {
      setCountrynymber('sz');
    } else if (val === 'Taiwan') {
      setCountrynymber('tw');
    } else if (val === 'Holy See (Vatican City)') {
      setCountrynymber('va');
    } else {
      setCountrynymber(getCode(val).toLowerCase());
    }

    setNationality(val);
  };

  const checkValids = useCallback(() => {
    return !(
      validfirstname &&
      validlastname &&
      validpublicphonenumber &&
      validnationality &&
      validemail &&
      validhomeaddress &&
      validfathername
    );
  }, [
    validemail,
    validfathername,
    validfirstname,
    validhomeaddress,
    validlastname,
    validnationality,
    validpublicphonenumber,
  ]);

  useEffect(() => {
    if (nationality.length > 2 && nationality.match('^[a-zA-Z ]*$') != null) {
      setValidNationality(true);
    } else {
      setValidNationality(false);
    }
  }, [nationality]);

  useEffect(() => {
    axios
      .get('https://ipapi.co/json/')
      .then((response) => {
        let data = response.data;
        counties.map((country) => {
          if (data.country_name === country.name) {
            setNationality(data.country_name);
          }
        });

        setCountrynymber(data.country_code.toLowerCase());
      })
      .catch((error) => {});
  }, []);

  useEffect(() => {
    checkValids();
  }, [checkValids]);

  useEffect(() => {
    if (firstname.length > 2 && firstname.match('^[a-zA-Z ]*$') != null) {
      setvalidFirstnamee(true);
    } else {
      setvalidFirstnamee(false);
    }
  }, [firstname]);

  useEffect(() => {
    if (lastname.length > 2 && lastname.match('^[a-zA-Z ]*$') != null) {
      setvalidLastname(true);
    } else {
      setvalidLastname(false);
    }
  }, [lastname]);

  useEffect(() => {
    let firstsent = email.lastIndexOf('@');
    let middlesent = email.lastIndexOf('.');

    if (firstsent >= 3 && middlesent - firstsent >= 4 && email.length - middlesent >= 3) {
      setvalidEmail(true);
    } else {
      setvalidEmail(false);
    }
  }, [email]);

  useEffect(() => {
    if (homeaddress.length > 7) {
      setvalidHomeAddress(true);
    } else {
      setvalidHomeAddress(false);
    }
  }, [homeaddress]);

  useEffect(() => {
    if (fathername.length > 2 && fathername.match('^[a-zA-Z ]*$') != null) {
      setvalidFathername(true);
    } else {
      setvalidFathername(false);
    }
  }, [fathername]);

  useEffect(() => {
    if (publicphonenumber.length >= 10 && publicphonenumber.match('^[0-9]*$') != null) {
      setvalidPublicphonenumber(true);
    } else {
      setvalidPublicphonenumber(false);
    }
  }, [publicphonenumber]);

  return (
    <div className="tw-mt-[100px]">
      <Container className="text-left mt-5 pt-2" style={{ background: '#d4d4d4', color: 'black' }}>
        <p className="text-left seorgesb">
          {t(
            'If you were lead to this page means you need a visa for visiting IRAN, you can apply for a visa with personal information and your travel document. '
          )}
        </p>
        <p
          style={{
            background: '#62a5ff',
            fontSize: '18px',
          }}
          className="text-left seorgesb mt-3 py-3 pl-2"
        >
          {t(
            'Notice: Regardless of your purpose of visit, our assisting agents will contact you for further details if needed. '
          )}
        </p>

        <p className="text-left">{t('Please prepare below data before applying. ')} </p>
        <p style={styles.font_weight_bold} className="text-left">
          {t('1 – Passport image: ')}
        </p>
        <p className="text-left">{t('Passport image requirements for applying for IRAN visa: ')} </p>
        <p className="text-left">
          A- Colorful and full frame image of Bio-data page of passport <br /> B- Image must be colorful <br /> C- Apart
          or whole of Image must not be covered with a part of your finger or shadow <br /> D- Passport image must be
          flat, deformation or perspective scans are not acceptable. <br /> E- Written Data must be clear and easy to
          read, resolution of image is important.
        </p>
        <p style={styles.font_weight_bold} className="text-left">
          {t('2 – Photograph: Visa photo requirement for IRAN visa') + ':'}
        </p>
        <p className="text-left">
          A- In color. <br /> B- Taken within the last 6 months.
          <br /> C- With no shadows.
          <br /> D- With a plain white background. <br />
          E- You must face the camera.
          <br /> F- Have a neutral expression.
          <br /> G- Have both eyes open.
          <br /> H- You cannot wear a uniform. <br /> I- Religious clothing as daily wearing is allowed. <br />
          J- The head must not be covered and the hairline has to be visible except religious reasons.
          <br /> K- The headdress must not cover the face.
          <br /> L- Without any worn electronic devices. Unless you need a hearing device or something similar. M- You
          must not wear eyeglasses except for medical reasons.
        </p>
        <p style={styles.font_weight_bold} className="text-left">
          3 – Personal information:{' '}
        </p>
        <p className="text-left">
          We need your father’s name, a telephone number, an email address and your home address.{' '}
        </p>
        <p
          style={{
            fontSize: '45px',
          }}
          className="text-center mt-5 test"
        >
          {t('Most Asked Questions ')}
        </p>
        <p style={styles.font_weight_bold} className="text-left mt-2 seorgesb">
          {t('1- How long does it valid? ')}
        </p>
        <p className="text-left seorge pt-0">{t('It is valid for maximum 30 days. ')}</p>
        <p style={styles.font_weight_bold} className="text-left seorgesb">
          {t('2- How much it costs? ')}{' '}
        </p>
        <p className="text-left seorge pt-0">
          {t(
            'Applicants who booked a service or tour with us will receive the visa grant notice for free. If you need only visa grant notice, we should charge you the administration fee which costs 20 EUR per case. Travelers with Visa grant notice must pay the visa fee which is different nationality by nationality at the preferred Embassy or Consulate of IRAN in your residence country or at one of Visa offices at International Airports in IRAN on arrival. '
          )}{' '}
        </p>
        <p style={styles.font_weight_bold} className="text-left seorgesb">
          {t('3- How long does it take to receive the visa grant notice? ')}{' '}
        </p>
        <p className="text-left seorge pt-0">
          {t(
            'It usually takes 4 working days from lodging date of the visa case at ministry server. It is recommended to apply much earlier to avoid risk of bureaucracy possible problems. '
          )}{' '}
        </p>
        <p style={styles.font_weight_bold} className="text-left seorgesb">
          {t('4- How many applicants can apply at once? ')}{' '}
        </p>
        <p className="text-left seorge pt-0">{t('Maximum 30 applicants can apply through one application. ')} </p>

        <p
          style={{
            fontSize: '45px',
          }}
          className="text-center mt-5 test"
        >
          {t('Visa Application Form ')}
        </p>

        <div className="my-5 py-5">
          <Form>
            <Form.Group as={Row} className="justify-content-center mb-3">
              <Form.Label className="font-weight-bold" column xs={isMobile ? '6' : '2'}>
                {t('First Name ')}
              </Form.Label>
              <Col xs={6} sm={10}>
                <Form.Control
                  isValid={validfirstname === true}
                  onChange={(e) => setFirstnamee(e.target.value.replace(/[0-9#<>~^{}\[\]]/, ''))}
                  value={firstname}
                  type="text"
                  placeholder="first name"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="justify-content-center mb-3">
              <Form.Label className="font-weight-bold" column xs={isMobile ? '6' : '2'}>
                {t('Last Name ')}
              </Form.Label>
              <Col xs={6} sm={10}>
                <Form.Control
                  isValid={validlastname === true}
                  onChange={(e) => setLastname(e.target.value.replace(/[0-9#<>~^{}\[\]]/, ''))}
                  value={lastname}
                  type="text"
                  placeholder="last name"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="justify-content-center mb-3">
              <Form.Label className="font-weight-bold" column xs={isMobile ? '6' : '2'}>
                {t('Email Address ')}
              </Form.Label>
              <Col xs={6} sm={10}>
                <Form.Control
                  isValid={validemail === true}
                  onChange={(e) => setEmail(e.target.value.replace(/[#<>~^{}\[\]]/, ''))}
                  value={email}
                  type="text"
                  placeholder="email address"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="justify-content-center mb-3">
              <Form.Label className="font-weight-bold" column xs={isMobile ? '6' : '2'}>
                {t('Nationality ')}
              </Form.Label>
              <Col xs={6} sm={10}>
                <CountryDropdown
                  value={nationality}
                  onChange={(val) => selectCountry(val)}
                  //style={validnationality ? { border: '1px solid #28af45' } : {}}
                  classes="form-control"
                  whitelist={[
                    'AL',
                    'AR',
                    'AM',
                    'AU',
                    'AT',
                    'AZ',
                    'BH',
                    'BY',
                    'BE',
                    'BA',
                    'BR',
                    'BG',
                    // "CA",
                    'CL',
                    'CN',
                    'CO',
                    'HR',
                    'CY',
                    'CZ',
                    'DK',
                    'EG',
                    'EE',
                    'FJ',
                    'FI',
                    'FR',
                    'GE',
                    'DE',
                    'GH',
                    'GR',
                    'HK',
                    'HU',
                    'IS',
                    'IN',
                    'ID',
                    'IQ',
                    'IE',
                    // "IL",
                    'IT',
                    'JP',
                    'JO',
                    'KZ',
                    'KR',
                    'KW',
                    'KG',
                    'LV',
                    'LB',
                    'LI',
                    'LT',
                    'LU',
                    'MO',
                    'MK',
                    'MG',
                    'MY',
                    'MV',
                    'ML',
                    'MT',
                    'MX',
                    'MC',
                    'MN',
                    'MA',
                    'MM',
                    'NA',
                    'NP',
                    'NL',
                    'NZ',
                    'NO',
                    'OM',
                    'PE',
                    'PH',
                    'PL',
                    'PT',
                    'PR',
                    'QA',
                    'RO',
                    'RU',
                    'SA',
                    'RS',
                    'SG',
                    'SK',
                    'SI',
                    'ZA',
                    'ES',
                    'SE',
                    'CH',
                    'TW',
                    'TJ',
                    'TH',
                    'TN',
                    'TR',
                    'TM',
                    'UA',
                    'AE',
                    // "GB",
                    // "US",
                    'UZ',
                    'VN',
                  ]}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="justify-content-center mb-3">
              <Form.Label className="font-weight-bold" column xs={isMobile ? '6' : '2'}>
                {t('Telephone Number ')}
              </Form.Label>
              <Col xs={6} sm={10}>
                <PhoneInput
                  inputStyle={
                    validpublicphonenumber ? { border: '1px solid #28af45', width: '100%' } : { width: '100%' }
                  }
                  buttonStyle={validpublicphonenumber ? { border: '1px solid #28af45' } : {}}
                  country={countrynumber}
                  value={publicphonenumber}
                  onChange={(phone) => setPublicphonenumber(phone)}
                  specialLabel=""
                  //maxlength="14"
                />{' '}
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="justify-content-center mb-3">
              <Form.Label className="font-weight-bold" column xs={isMobile ? '6' : '2'}>
                {t('Home Address ')}
              </Form.Label>
              <Col xs={6} sm={10}>
                <Form.Control
                  isValid={validhomeaddress === true}
                  onChange={(e) => setHomeAddress(e.target.value.replace(/[#<>~^{}\[\]]/, ''))}
                  value={homeaddress}
                  type="text"
                  as="textarea"
                  //rows="2"
                  placeholder="home address"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="justify-content-center mb-3">
              <Form.Label className="font-weight-bold" column xs={isMobile ? '6' : '2'}>
                {t("Father's Name ")}
              </Form.Label>
              <Col xs={6} sm={10}>
                <Form.Control
                  isValid={validfathername === true}
                  onChange={(e) => setFathername(e.target.value.replace(/[0-9#<>~^{}\[\]]/, ''))}
                  value={fathername}
                  type="text"
                  placeholder="father's name"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="justify-content-center mb-3">
              <Form.Label className="font-weight-bold" column xs={isMobile ? '6' : '2'}>
                {t('Start Date ')}
              </Form.Label>
              <Col xs={6} sm={10}>
                <DatePicker
                  className="form-control"
                  minDate={new Date()}
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="justify-content-center mb-3">
              <Form.Label className="font-weight-bold" column xs={isMobile ? '6' : '2'}>
                {t('Duration ')}
              </Form.Label>
              <Col xs={6} sm={10}>
                <InputGroup className="mb-3">
                  <InputGroup.Text>
                    <Button
                      style={{
                        zIndex: 0,

                        background: '#521231',
                        border: '1px solid #521231',
                      }}
                      onClick={() => {
                        counter2 !== 1 && setCounter2(counter2 - 1);
                      }}
                    >
                      -
                    </Button>
                  </InputGroup.Text>
                  <FormControl
                    onChange={(e) => {
                      if (parseInt(e.target.value) <= 30) {
                        setCounter2(parseInt(e.target.value.replace(/[#<>~^{}\[\]]/, '')));
                      }
                    }}
                    style={{ textAlign: 'center' }}
                    value={counter2}
                    aria-describedby="basic-addon1"
                    max="30"
                    // onKeyUp={(e) => {
                    //   e.target.value > 3 && setCounter2(null);
                    // }}
                  />
                  <InputGroup.Text>
                    <Button
                      style={{
                        zIndex: 0,

                        background: '#521231',
                        border: '1px solid #521231',
                      }}
                      className="btn-dark"
                      onClick={() => {
                        counter2 !== 30 && setCounter2(counter2 + 1);
                      }}
                    >
                      +
                    </Button>
                  </InputGroup.Text>
                </InputGroup>
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="justify-content-center mb-3">
              <Form.Label className="font-weight-bold" column xs={isMobile ? '6' : '2'}>
                {t('Passport image ')}
              </Form.Label>
              <Col xs={6} sm={10}>
                <Form.Control onChange={handlePassport} type="file" placeholder="name" />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="justify-content-center mb-3">
              <Form.Label className="font-weight-bold" column xs={isMobile ? '6' : '2'}>
                {t('Photograph ')}
              </Form.Label>
              <Col xs={6} sm={10}>
                <Form.Control onChange={handlePhotograph} type="file" placeholder="name" />
              </Col>
            </Form.Group>
          </Form>

          <Row className="mt-3">
            <Col sm={{ span: 2, offset: 8 }} xs={{ span: 4, offset: 8 }}>
              <a style={{ textDecoration: 'none' }} href="#">
                <Button
                  disabled={checkValids() || isSubmitting}
                  onClick={(e) => submitVisa(e)}
                  style={
                    checkValids()
                      ? {
                          background: '#5e0832',
                          borderColor: '#5e0832',
                          fontSize: '17px',
                          fontWeight: 'bold',
                          cursor: 'not-allowed',
                          textDecoration: 'none',
                        }
                      : {
                          background: '#5e0832',
                          borderColor: '#5e0832',
                          fontSize: '17px',
                          fontWeight: 'bold',
                        }
                  }
                  className="btn-dark btn-block"
                  type="submit"
                >
                  {isSubmitting ? <Spinner size="sm" animation="border" /> : t('Submit ')}
                </Button>
              </a>
              <Recaptcha
                className="mr-4"
                ref={recaptchaRef}
                sitekey="6Le95fgUAAAAADD5TOzPmqiX-IrErnTrqS6ABjUx"
                //onChange={onChange}
              />
            </Col>
          </Row>

          {apiErrors && Object.keys(apiErrors).length > 0 && (
            <Alert variant="danger" className="mt-3">
              <Alert.Heading>Validation failure.</Alert.Heading>
              <ul className="p-0 mb-0 list-unstyled">
                {Object.keys(apiErrors).map((item) => (
                  <li key={item}>
                    {item}:{apiErrors[item][0]}
                  </li>
                ))}
              </ul>
            </Alert>
          )}
        </div>
      </Container>
    </div>
  );
};

export default Client;
